/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// START - select delivery day on cart page
if (window.location.pathname.indexOf('cart') > -1) {
  var attributeToString = function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return attribute.trim();
  }

  var selectDeliveryDay = function(key, value) {
    var attribute = attributeToString(value);

    var data = {attributes: {
      "Delivery Day": attribute
    }};

    fetch("".concat(window.routes.cartUrl, "/update.js"), {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    });
  }

  function rdbDeliveryDayChangeHandler(event) {
      var rdbValue = this.value;
      selectDeliveryDay("Delivery Day", rdbValue)
  }

  var deliveryDayRadios = document.querySelectorAll('input[type=radio][name="rdbDeliveryDay"]');
  Array.prototype.forEach.call(deliveryDayRadios, function(radio) {
     radio.addEventListener('change', rdbDeliveryDayChangeHandler);
  });

  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    var deliveryDayTuesday = document.getElementById("delivery-day-tuesday");
    if (deliveryDayTuesday && data.attributes && data.attributes["Delivery Day"] === "Tuesday") {
      deliveryDayTuesday.checked = true;
    }
    var deliveryDayThursday = document.getElementById("delivery-day-thursday");
    if (data.attributes && data.attributes["Delivery Day"] === "Thursday") {
      deliveryDayThursday.checked = true;
    }
    var deliveryDayPickup = document.getElementById("delivery-day-pickup");
    if (data.attributes && data.attributes["Delivery Day"] === "Pickup") {
      deliveryDayPickup.checked = true;
    }
  });
  
  var checkForDeliveryDayValue = function(e) {
    var deliveryDayTuesday = document.getElementById("delivery-day-tuesday").checked;
    var deliveryDayThursday = document.getElementById("delivery-day-thursday").checked;
    var deliveryDayPickup = document.getElementById("delivery-day-pickup").checked;
    if (!deliveryDayTuesday && !deliveryDayThursday && !deliveryDayPickup) {
        e = e || window.event;
        // validation code

        // if invalid
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      
        var requiredMessage = document.getElementById("delivery-day-required");
    requiredMessage.style.display = requiredMessage.style.display === 'none' ? '' : '';
    }
  }
  

  var submit = document.getElementById("cart-checkout-button");
  if (submit.addEventListener) {
    submit.addEventListener("click", checkForDeliveryDayValue);
  } else {
    submit.attachEvent("onclick", checkForDeliveryDayValue);
  }
}
// END - select delivery day on cart page